import { Route } from '@angular/router';
import { share } from './share';
import { SbIcons } from '@ngx-seatback/icons';
import { RoutingID } from '../../../sb-routing-enum';
import { deals } from './deals';

export const marketing: Route = {
  path: 'marketing',
  title: 'nav.marketing',
  data: {
    icon: SbIcons.hammerAd,
    breadcrumb: 'nav.marketing',
  },
  children: [
    {
      path: '',
      redirectTo: RoutingID.networkShare,
      pathMatch: 'full',
      data: {
        breadcrumb: '',
      },
    },
    share,
    deals,
  ],
};
